import React from "react";
import Icon from "./Icon";

export function EmptyState({ icon, title, subtitle }) {
  return (
    <div style={{ textAlign: "center", padding: "52px 20px" }}>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 48,
          height: 48,
          borderRadius: 12,
          background: "#F3F4F6",
          marginBottom: 12,
        }}
      >
        <Icon name={icon} size={22} color="#9CA3AF" />
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>
        {title}
      </div>
      <div style={{ fontSize: 12, color: "#9CA3AF", marginTop: 4 }}>
        {subtitle}
      </div>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div style={{ textAlign: "center", padding: "48px 20px" }}>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 48,
          height: 48,
          borderRadius: 12,
          background: "#FEF2F2",
          marginBottom: 12,
        }}
      >
        <Icon name="alert" size={22} color="#DC2626" />
      </div>
      <div
        style={{
          fontSize: 14,
          color: "#DC2626",
          fontWeight: 500,
          marginBottom: 10,
        }}
      >
        {message}
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "7px 14px",
            background: "#1D4ED8",
            color: "#fff",
            border: "none",
            borderRadius: 7,
            fontSize: 12,
            cursor: "pointer",
          }}
        >
          <Icon name="refresh" size={13} color="#fff" /> Retry
        </button>
      )}
    </div>
  );
}
